module.exports = __webpack_public_path__ + "img/news3.269c6fba.jpg";